import { render, staticRenderFns } from "./work-menu-top.vue?vue&type=template&id=70fadf98&scoped=true"
import script from "./work-menu-top.vue?vue&type=script&lang=ts"
export * from "./work-menu-top.vue?vue&type=script&lang=ts"
import style0 from "./work-menu-top.vue?vue&type=style&index=0&id=70fadf98&prod&lang=less&scoped=true"
import style1 from "./work-menu-top.vue?vue&type=style&index=1&id=70fadf98&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fadf98",
  null
  
)

export default component.exports